import Vue from "vue";
import axios from "axios";
import { penddingPaymentColumns } from "@/columns";
import ActivityFlowDialogLocker from "@/components/activity_flow/ActivityFlowDialogLocker.vue";
//import PromessFormDrawer from "@/components/activity_flow/PaymentPromessDrawer.vue";

const vue = new Vue();

export const penddingPaymentgetTableData = async function (currentUser) {
  //console.log("penddingPaymentgetTableData");
  const axiosSource = axios.CancelToken.source();
  let tableData = [];
  if (
    //currentUser.Roles.some((e) => e.Id === 25 || e.Id === 6)
    //currentUser.PositionID == 52 ||
    currentUser.PositionID == 34 ||
    currentUser.PositionID == 117 ||
    currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetCollectionStat", {
        cancelToken: axiosSource.token,
        timeout: 3 * 60 * 1000,
        params: {
          CompanyCode: currentUser.CompanySelected,
          UserName: currentUser.UserName,
          EmployeeId: currentUser.EmployeeId,
          PersonCode: currentUser.PersonCode
        }
      })
      .then((resp) => {
        tableData = resp.data[5].NoPromisedPaymentDate;
      })
      .catch((error) => console.error(error));

    return tableData;
  } else {
    return tableData;
  }
};

export const PendingColumns = penddingPaymentColumns;

export const penddingPaymentActions = [
  {
    icon: "el-icon-date",
    label: "Cambiar fecha de pago",
    command: "change-date-payment"
  },
  {
    icon: "el-icon-chat-line-square",
    label: "Ver comentario",
    command: "see-comments"
  }
];

export const penddingPaymentActionHandler = async function (action) {
  // let rowData = {
  //   task: action.row
  // };
  //console.log(ChargesStat);
  ActivityFlowDialogLocker.methods.actionHandlerHelper(action);
  // switch (action.command) {
  //   case "change-date-payment":
  //     action.refs.PromessFormDrawer.show(action.row /*, true, false, false*/);
  //     break;

  //   case "see-comments":
  //     action.refs.PromessFormDrawer.show(action.row /*, false, false, true*/);
  //     break;
  // }
  // return action;
};
